<template>
    <div class="time-container">
        <table class="time-table">
            <tr class="numbers">
                <td v-if="times.years"> {{times.years}} </td>
                <td> {{times.days}} </td>
                <td> {{times.hours}} </td>
                <td> {{times.mins}} </td>
                <td class="secs"> {{times.secs}} </td>
            </tr>
            <tr class="labels">
                <td v-if="times.years"> Años </td>
                <td> Días </td>
                <td> Horas </td>
                <td> Minutos </td>
                <td> Segundos </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "countup",
        props: {
            date: {
                type: Date,
                required: true
            }
            },
            data() {
                return {
                    times: {
                        secs: 0,
                        mins: 0,
                        hours: 0,
                        days: 0
                    }
            }
            },
            mounted() {
                this.timeInterval = setInterval(_=>this.calcTimes(), 250);
            },
            beforeDestroy () {
                clearInterval(this.timeInterval)
            },
            methods: {
                calcTimes(){
                    const diffTime = Math.abs(new Date() - this.date);
                    const days = (Math.floor(diffTime / (1000 * 60 * 60 * 24)).toString().padStart(2,'0'));
                    let years = days>= 365 ? (Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365)).toString().padStart(2,'0')) : false;
                    this.times={
                        secs: (Math.floor(diffTime / (1000)) % 60).toString().padStart(2,'0'),
                        mins: (Math.floor(diffTime / (1000 * 60)) % 60).toString().padStart(2,'0'),
                        hours: (Math.floor(diffTime / (1000 * 60 * 60)) % 24).toString().padStart(2,'0'),
                        days: days % 365,
                        years: years
                    }
                }

            }
        }
</script>

<style scoped>
    .time-container{
        display: flex;
        align-content: center;
        margin: auto;
        width: 100%;
    }
    .time-table{
        margin: auto;
    }
    .numbers{
        font-size: 10rem;
    }
    .numbers>td{
        padding-left: 25px;
        padding-right: 25px;
        font-family: DSEG7-Modern;
        font-weight: bold;
        color: #20313d
    }
    .numbers>td.secs{
        color: #cc3333
    }
    .labels{
        font-size: 1.3rem;
    }
</style>